import { createFieldMap } from '@tanstack/react-form'

import { useFlag } from '~/hooks/useFlag'

import { withFieldGroup } from '../../Form/formHooks'
import { FormSectionWrapper } from '../../Form/FormWrapper'
import { defaultFormValues, type FormPractitionerProfile } from './formState'
import { PractitionerStaffingConfigFields } from './PractitionerStaffingConfig'
import { SurgeryTypeGroupFields } from './SurgeryTypeGroupFields'

const defaultValues: FormPractitionerProfile = defaultFormValues.activeProfile

const profileFieldMap = createFieldMap(defaultValues)

type ProfileFieldsProps = {
    size?: 'compact' | 'default'
}
export const ProfileFields = withFieldGroup({
    defaultValues,
    props: {
        size: 'default',
    } as ProfileFieldsProps,
    render: function Render({ group, size }) {
        const isExpertEnabled = useFlag('hospital_configuration_expert')

        return (
            <>
                <FormSectionWrapper
                    title={`Hvilke inngrep skal kirurgen gjøre${size === 'compact' ? ' i denne perioden?' : '?'}`}
                    description={
                        "Viser hvilke operasjonskategorier og operasjonstyper kirurgen skal gjøre som hovedoperatør og kun som assistent (må stå sammen med hovedoperatør). Hvis kirurgen kan være hovedoperatør bør operasjonsgruppen(e) flyttes fra 'Assistent' til 'Hovedoperatør'."
                    }
                    size={size}
                >
                    <SurgeryTypeGroupFields form={group} fields={profileFieldMap} />
                </FormSectionWrapper>

                {isExpertEnabled && <PractitionerStaffingConfigFields form={group} fields={profileFieldMap} size={size} />}
            </>
        )
    },
})
